/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WinningCriteria,
    WinningCriteriaFromJSON,
    WinningCriteriaFromJSONTyped,
    WinningCriteriaToJSON,
} from './';

/**
 * Collection contains the user\'s reward stats/progress.
 * @export
 * @interface CreateSponsoredRewardRequest
 */
export interface CreateSponsoredRewardRequest {
    /**
     * 
     * @type {WinningCriteria}
     * @memberof CreateSponsoredRewardRequest
     */
    winningCriteria: WinningCriteria;
    /**
     * 
     * @type {string}
     * @memberof CreateSponsoredRewardRequest
     */
    rewardConfigId: string;
}

export function CreateSponsoredRewardRequestFromJSON(json: any): CreateSponsoredRewardRequest {
    return CreateSponsoredRewardRequestFromJSONTyped(json, false);
}

export function CreateSponsoredRewardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSponsoredRewardRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'winningCriteria': WinningCriteriaFromJSON(json['winningCriteria']),
        'rewardConfigId': json['rewardConfigId'],
    };
}

export function CreateSponsoredRewardRequestToJSON(value?: CreateSponsoredRewardRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'winningCriteria': WinningCriteriaToJSON(value.winningCriteria),
        'rewardConfigId': value.rewardConfigId,
    };
}


